<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet width="100%" height="100%" class="overflow-hidden overflow-y-auto mt-5">
      <i-search-panel :searchPanel="searchPanel"></i-search-panel>
      <DxDataGrid
        id="acGrid"
        class="layout-col-height02"
        style="width: 100%; height:100%"
        :ref="gridRef"
        :data-source="gridData"
        :remote-operations="false"
        :hover-state-enabled="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :row-alternation-enabled="true"
        :column-auto-width="true"
        :show-borders="true"
        :show-row-lines="true"
        :focused-row-enabled="true"
        :selection="{ mode: 'single' }"
        show-column-totals
        key-expr="orderId"
      >
        <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
        <DxColumn data-field="userCd" data-type="string" :visible="false"></DxColumn>
        <DxColumn data-field="orderId" data-type="string" alignment="center" width="350px" caption="주문번호" :allow-editing="false" />
        <DxColumn data-field="clntNm" data-type="string" alignment="center" width="200px" caption="고객사 명" :allow-editing="false" />
        <DxColumn data-field="constructNm" data-type="string" alignment="center" width="200px" caption="사업장(공사)명" :allow-editing="false" />
        <DxColumn data-field="approvedAt" data-type="string" alignment="center" caption="거래시간" width="200px" :allow-editing="false" />
        <DxColumn data-field="transferName" data-type="string" alignment="center" caption="입금자명" width="200px" :allow-editing="false" />

        <DxColumn data-field="feeName" data-type="string" alignment="center" width="200px" caption="요금제명" :allow-editing="false" />
        <DxColumn
          data-field="feeAmountMonth"
          data-type="number"
          alignment="right"
          width="120px"
          caption="월 요금"
          :allow-editing="false"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="paymentAmount"
          data-type="number"
          alignment="right"
          width="200px"
          caption="결제 금액"
          :allow-editing="false"
          header-cell-template="tooltip-payment-header"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="extraAmount"
          data-type="number"
          alignment="right"
          width="150px"
          caption="컨설팅 금액"
          :allow-editing="false"
          cell-template="amountCellTemplate"
        />
        <DxColumn
          data-field="vat"
          data-type="number"
          alignment="right"
          width="120px"
          caption="VAT"
          :allow-editing="false"
          cell-template="amountCellTemplate"
        />
        <template #amountCellTemplate="{ data: cellInfo  }">
          <div>{{ formatToKoreanWon(cellInfo.value) + '원' }}</div>
        </template>
        <template #tooltip-payment-header="{ data }">
          <div>
            <!-- <p style="font-size:16px"></p> -->
            {{ data.column.caption }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>{{ '요금 금액 + 컨설팅 금액 + VAT' }}</span>
            </v-tooltip>
          </div>
        </template>
        />
        <DxSummary :calculate-custom-summary="calculateCustomSummary">
          <DxTotalItem column="orderId" summary-type="count" display-format="{0}건" />
          <DxTotalItem column="paymentAmount" name="amountVatSum" summary-type="custom" display-format="{0}원" :customize-text="customizeTotalText" />
          <DxTotalItem column="extraAmount" summary-type="sum" display-format="{0}원" :customize-text="customizeText" />
        </DxSummary>
      </DxDataGrid>
    </v-sheet>
  </v-container>
</template>
<script>
import iSearchPanel from '@/components/common/iSearchPanel.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
// 출력 관련
import { Workbook } from 'exceljs'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { saveAs } from 'file-saver-es'
import { exportDataGrid as exportExcel } from 'devextreme/excel_exporter'
import { exportDataGrid as exportPdf } from 'devextreme/pdf_exporter'
import malgun from '@/assets/font/malgun.ttf'
import { getSettlementHistory } from '@/api/feeManage/settlementHistory.js'
export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'sattlementHistory',
  components: {
    iSearchPanel
  },
  data() {
    return {
      gridRef: 'acGrid',
      gridData: [],
      totalAmount: 0,
      searchPanel: true
    }
  },
  computed: {},
  beforeMount() {},
  activated() {},
  mounted() {},
  methods: {
    customizeText(options) {
      // 출력되는 합계금액 커스텀
      return this.formatToKoreanWon(options.value) + '원'
    },
    customizeTotalText(options) {
      // 출력되는 합계금액 커스텀
      return '합계: ' + this.formatToKoreanWon(this.totalAmount) + '원'
    },

    calculateCustomSummary(options) {
      if (options.summaryProcess === 'start') {
        this.totalAmount = 0
      }
      if (options.summaryProcess === 'finalize') {
        const dataSource = options.component.option('dataSource') // 데이터 소스에서 데이터를 가져오기
        dataSource.forEach(item => {
          this.totalAmount += parseInt(item.paymentAmount)
        })
        console.log('최종 합계 값:', this.totalAmount)
      }
    },

    async btnSearch(param, isNotify = true) {
      // 토스 일반요금 정산 내역
      this.totalAmount = 0
      param.orderType = 'AC'
      this.openLoading()
      getSettlementHistory(param, isNotify)
        .then(res => {
          this.gridData = res.list
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnPrint(type, title, docTitle) {
      if (type == 'xls') {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet(title)
        exportExcel({
          component: this.GetDataGrid(this.gridRef),
          worksheet,
          autoFilterEnabled: true
        }).then(() => {
          workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${title}${docTitle}`)
          })
        })
      }
      if (type == 'pdf') {
        const doc = new jsPDF()
        doc.addFont(malgun, 'malgun', 'normal')

        exportPdf({
          jsPDFDocument: doc,
          component: this.GetDataGrid(this.gridRef),
          autoTableOptions: {
            styles: {
              font: 'malgun'
            }
          }
        }).then(() => {
          doc.save(`${title}.pdf`)
        })
      }
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      } else return 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/theme/variables.scss';
.echartBar {
  height: calc((100vh - 370px));
}
.dashcard-title {
  font-size: 1rem;
  font-weight: 600;
  line-height: normal;
  color: $main_text;
}
.chart-status {
  width: 100%;
  // height: 10%;
  // display: flex;
  // justify-content: space-between;
  align-items: center;
  padding: 1rem 20px;
  background: #f3f6fa;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}
.chart-status-sub {
  width: 100%;
  height: 10%;
  align-items: center;
  padding: 1rem 20px;
  background: #f3f6fa;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}
.chart-status-detail {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.cs-data {
  width: 100%;
  padding: 0.4rem 10px;
  background: #ffffff;
  border-radius: 8px;
  text-align: right;
  display: flex;
  justify-content: space-between;
  color: #a0a4ad;
  font-size: 1rem;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
}
.chart-title {
  font-size: 1rem;
  font-weight: 600;
  line-height: normal;
  color: $main_text;
  display: flex;
  align-items: center;
}
.chart-title-sub {
  font-size: 0.9rem;
  font-weight: 500;
  line-height: normal;
  color: $main_text;
  display: flex;
  align-items: center;
}
</style>
